import { Modal } from 'antd';

export default Modal;



// WEBPACK FOOTER //
// ./src/components/ui-ant/Feedback/modal.js